// moment with time zones, but only the three the site uses (London, Rome, Sofia): the full world data is 700 KB.
// timeZones.json is cut from moment-timezone's data/packed/latest.json; recut it when adding a zone.
import moment from 'moment-timezone/moment-timezone';
import zones from './timeZones.json';

moment.tz.load(zones);

export default moment;
